export const createExcel = (content, title) => {
  const blob = new Blob([content], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const elink = document.createElement("a");
  elink.download = title + ".xlsx";
  elink.style.display = "none";
  elink.href = URL.createObjectURL(blob);
  document.body.appendChild(elink);
  elink.click();
  URL.revokeObjectURL(elink.href);
  document.body.removeChild(elink);
}


// WEBPACK FOOTER //
// ./src/utils/tools.js